import { Injectable } from '@angular/core';
import { BrowserCheckService } from './browser-check.service';

@Injectable({
  providedIn: 'root',
})
export class PermissionCacheService {
  private readonly CACHE_DURATION = 2 * 60 * 1000; // 2 minutes (reduced from 5 for more responsive updates)

  constructor(private browserCheck: BrowserCheckService) {}

  cachePermissions(sysAdmin: string, lead: string, buyer: string) {
    this.browserCheck.setSessionStorage('UserTypeSysAdmin', sysAdmin);
    this.browserCheck.setSessionStorage('UserTypeLead', lead);
    this.browserCheck.setSessionStorage('UserTypeBuyer', buyer);
    this.browserCheck.setSessionStorage(
      'LastPermissionCheck',
      Date.now().toString()
    );
  }

  getCachedPermissions(): {
    sysAdmin: string;
    lead: string;
    buyer: string;
    isValid: boolean;
  } {
    const cachedSysAdmin =
      this.browserCheck.getSessionStorage('UserTypeSysAdmin');
    const cachedLead = this.browserCheck.getSessionStorage('UserTypeLead');
    const cachedBuyer = this.browserCheck.getSessionStorage('UserTypeBuyer');
    const lastPermissionCheck = this.browserCheck.getSessionStorage(
      'LastPermissionCheck'
    );

    if (
      cachedSysAdmin !== null &&
      cachedLead !== null &&
      cachedBuyer !== null &&
      lastPermissionCheck
    ) {
      const cacheExpiry = Date.now() - this.CACHE_DURATION;
      const isValid = parseInt(lastPermissionCheck) > cacheExpiry;

      return {
        sysAdmin: cachedSysAdmin,
        lead: cachedLead,
        buyer: cachedBuyer,
        isValid,
      };
    }

    return {
      sysAdmin: '',
      lead: '',
      buyer: '',
      isValid: false,
    };
  }

  clearCache() {
    this.browserCheck.removeSessionStorage('UserTypeSysAdmin');
    this.browserCheck.removeSessionStorage('UserTypeLead');
    this.browserCheck.removeSessionStorage('UserTypeBuyer');
    this.browserCheck.removeSessionStorage('LastPermissionCheck');
  }

  forceRefreshPermissions() {
    // Clear cache to force fresh API call on next permission check
    this.clearCache();
  }
}
